// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Bonding } from './bonding';
import { Rate } from './rate';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class RateValue extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  rateValueId!: number;
  createdBy!: string;
  createdDate!: Date;
  fromValue!: number;
  rateId!: number;
  rateValue1!: number;
  rateValue2!: string;
  toValue!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  bondings!: Bonding[];
  rate!: Rate;
}

